import React, { useState, useEffect } from "react";
import AccordionItems from "./AccordionItems";
import { Modal, Accordion, Button, Form, Table, Spinner } from 'react-bootstrap';
import { api } from "../../../services/api";
import { toast } from "react-toastify";
import styles from '../../../styles/MP/LaboratorioCemPorcentoRetorno.module.scss';
import { useMisc } from "../../../contexts/MiscContext";
import PecasIncluidas from "./PecasIncluidas";
import CookiesService from "../../../services/cookies";
import OptionsSection from "./options_section";

const userLogin = CookiesService.getUserLogin();

// Modal de perdas deve aparecer SEMPRE que houver peças incluídas

const ResultadoTestes = ({ acaoSelecionada, showResultadoTestes, setShowResultadoTestes, linhaSelecionada, setLinhaSelecionada, pecas, setPecas, setBusca, finalizarComConfirmacao }) => {
    const acao = acaoSelecionada.value === 'cemPorcento' ? 0 : 1;
    const { setShowLoading, showLoading } = useMisc();
    const [isProcessing, setIsProcessing] = useState(false);

    const [pecasSelecionadas, setPecasSelecionadas] = useState([]);
    const [pecasIncluidas, setPecasIncluidas] = useState([]);
    const [testes, setTestes] = useState([]);
    const [indices, setIndices] = useState([]);
    const [testeEscolhido, setTesteEscolhido] = useState({});
    const [indiceEscolhido, setIndiceEscolhido] = useState({});
    const [statusEscolhido, setStatusEscolhido] = useState('');
    const [gramaturaEncontrada, setGramaturaEncontrada] = useState('');
    const [larguraEncontrada, setLarguraEncontrada] = useState('');
    const [observacoes, setObservacoes] = useState('');
    const [listaPecas, setListaPecas] = useState([]);
    const [listaTestes, setListaTestes] = useState([]);
    const [listaIndices, setListaIndices] = useState([]);
    const [listaIndicesFiltrada, setListaIndicesFiltrada] = useState([]);
    const [pecasPosicoes, setPecasPosicoes] = useState({});
    const [qtdeTotalTestes, setQtdeTotalTestes] = useState(0);

    useEffect(() => {
        if (linhaSelecionada.nf_entrada === undefined) return;
        (async () => {
            try {
                const res = await api.get('MP/LaboratorioCemPorcentoRetorno/get-options', { params: linhaSelecionada });
                setListaPecas(res.data.resPecas);
                setListaTestes(res.data.resTestes);
                setListaIndices(res.data.resIndices);

                const qtdeTotal = res.data.resTestes.reduce((acc, teste) => {
                    return acc + teste.pecas.length;
                }, 0);
                setQtdeTotalTestes(qtdeTotal);
            } catch (e) {
                toast.error('Ocorreu um erro ao carregar os dados da tela, por favor cheque sua internet e/ou entre contato com o suporte');
            }
        })();
    }, [linhaSelecionada]);

    useEffect(() => {
        if (pecasSelecionadas.length === 0) {
            setListaIndicesFiltrada([]);
            setTesteEscolhido({});
            setIndiceEscolhido({});
            setStatusEscolhido('');
        }

        for (let i = 0; i < listaTestes.length; i++) {
            const teste = listaTestes[i];
            if (pecasSelecionadas.length === 0) { listaTestes[i].disabled = true; continue; }

            const contemPecas = pecasSelecionadas.every(peca => teste.pecas.includes(peca));
            const jaIncluido = pecasIncluidas.some(entry =>
                pecasSelecionadas.includes(entry.peca) && entry.id_teste === teste.id_teste
            );

            listaTestes[i].disabled = !(contemPecas && !jaIncluido);
        }

        setTesteEscolhido({});
        setIndiceEscolhido({});
        setStatusEscolhido('');

        setListaTestes([...listaTestes]);
    }, [pecasSelecionadas]);

    useEffect(() => {
        if (!testeEscolhido?.id_teste) {
            setListaIndicesFiltrada([]);
            setIndiceEscolhido({});
            return;
        }
        const indiceFiltrado = listaIndices.filter(indice => indice.id_teste === testeEscolhido.id_teste);
        setListaIndicesFiltrada([...indiceFiltrado]);
        setIndiceEscolhido({});
        setStatusEscolhido('');
    }, [testeEscolhido]);

    const resetState = () => {
        setPecasSelecionadas([]);
        setTestes([]);
        setIndices([]);
        setTesteEscolhido({});
        setIndiceEscolhido({});
        setStatusEscolhido('');
        setGramaturaEncontrada('');
        setLarguraEncontrada('');
        setObservacoes('');
    }

    const handleCloseResultadoTestes = () => {
        resetState();
        setShowResultadoTestes(false);
        setPecas([]);
        setLinhaSelecionada({});
        setPecasSelecionadas([]);
        setPecasIncluidas([]);
        setTestes([]);
        setIndices([]);
        setTesteEscolhido({});
        setIndiceEscolhido({});
        setStatusEscolhido('');
        setGramaturaEncontrada('');
        setLarguraEncontrada('');
        setObservacoes('');
        setListaPecas([]);
        setListaTestes([]);
        setListaIndices([]);
        setListaIndicesFiltrada([]);
    }

        const handleSearch = async () => {
        if (!linhaSelecionada || !linhaSelecionada.nf_entrada) {
            toast.warning('Nenhuma linha selecionada para buscar os dados.');
            return;
        }
    
        const info = { ...linhaSelecionada, acao: 0 }; 
        try {
            setShowLoading(true); 
            const res = await api.get('MP/LaboratorioCemPorcentoRetorno/get-cemporcento', { params: info });
    
            if (res.data) {
                setListaPecas(res.data.resPecas || []); 
                setListaTestes(res.data.resTestes || []); 
            } else {
                toast.warning('Nenhum dado encontrado.');
            }
        } catch (e) {
            toast.error('Erro ao buscar os dados. Verifique sua conexão ou entre em contato com o suporte.');
        } finally {
            setShowLoading(false); 
        }
    };

    // Função para calcular quantidade de perda baseado no status reprovado
    const calcularQuantidadePerda = (peca) => {
        // Para cada peça reprovada, considerar a metragem total como perda
        const pecaInfo = listaPecas.find(p => p.peca === peca.peca);
        if (!pecaInfo) return 0;

        // Se reprovado, perda é a metragem total
        if (peca.status === 'Reprovado') {
            return parseFloat(pecaInfo.metragem || 0);
        }
        
        return 0;
    };

    // Mapear TODAS as peças para o modal de perdas (independente de aprovação/reprovação)
    const mapearPecasParaModalPerdas = () => {
        // Agrupar peças incluídas por peça
        const pecasAgrupadas = {};
        
        pecasIncluidas.forEach(item => {
            if (!pecasAgrupadas[item.peca]) {
                pecasAgrupadas[item.peca] = [];
            }
            pecasAgrupadas[item.peca].push(item);
        });

        // Mapear TODAS as peças (não filtra por reprovação)
        const todasPecas = Object.keys(pecasAgrupadas)
            .map(peca => {
                const testesDaPeca = pecasAgrupadas[peca];
                const temReprovacao = testesDaPeca.some(teste => teste.status === 'Reprovado');

                const pecaInfo = listaPecas.find(p => p.peca === peca);
                if (!pecaInfo) {
                    return null;
                }

                // Calcular quantidade de perda sugerida (usuário pode alterar)
                // Se reprovado, sugere a metragem total, senão sugere 0
                const quantidadePerdaSugerida = temReprovacao ? parseFloat(pecaInfo.metragem || 0) : 0;

                return {
                    peca: peca,
                    metroForn: pecaInfo.metragem || 0,
                    relogio: pecaInfo.metragem || 0,
                    largForn: 0,
                    largAferida: 0,
                    ourela: 0,
                    qtdeLancar: quantidadePerdaSugerida, // Sugestão inicial
                    motivoSelecionado: -1,
                    defeitos: testesDaPeca.map(teste => ({
                        teste: teste.desc_teste,
                        indice: teste.indice,
                        status: teste.status,
                        gram_enc: teste.gram_enc,
                        larg_enc: teste.larg_enc,
                        obs: teste.obs,
                        perda: teste.status === 'Reprovado',
                        qntPerda: teste.status === 'Reprovado' ? parseFloat(pecaInfo.metragem || 0) : 0
                    }))
                };
            })
            .filter(peca => peca !== null);

        return todasPecas;
    };

    // Mapear amostra para o modal de perdas
    const mapearAmostraParaModalPerdas = () => {
        if (acaoSelecionada.value === 'cemPorcento') {
            return {
                material: linhaSelecionada.material,
                cormaterial: linhaSelecionada.cor_material,
                descricaomaterial: linhaSelecionada.desc_material || '',
                nomeCliFor: linhaSelecionada.fornecedor || '',
                nfentrada: linhaSelecionada.nf_entrada,
                serieNF: '',
                pedido: linhaSelecionada.pedido
            };
        } else {
            return {
                material: linhaSelecionada.produto || '',
                cormaterial: '',
                descricaomaterial: linhaSelecionada.desc_produto || '',
                nomeCliFor: linhaSelecionada.fornecedor || '',
                ordem_producao: linhaSelecionada.ordem_producao,
                ordem_servico: linhaSelecionada.ordem_servico
            };
        }
    };

    const processarFinal = async () => {
        setShowLoading(true);
    
        if (acaoSelecionada.value === 'cemPorcento') {
            const send = {
                acao: 0,
                cemPorcento: {
                    nf_entrada: linhaSelecionada.nf_entrada,
                    material: linhaSelecionada.material,
                    cor_material: linhaSelecionada.cor_material,
                    pedido: linhaSelecionada.pedido
                },
                cemPorcentoLab: pecasIncluidas
            };
            try {
                const res = await api.post('MP/LaboratorioCemPorcentoRetorno/process-labCemPorcentoRetorno', { send });
                if (res.status === 200) {
                    await handleSearch();
                    setShowResultadoTestes(false);
                    toast.success('Dados inseridos com sucesso!');
                } else {
                    toast.error(`Erro, status code: "${res.status}". Entre em contato com o suporte.`);
                }
            } catch (e) {
                toast.error(`Erro ao processar as peças.`);
            } finally {
                setShowLoading(false);
                setIsProcessing(false);
            }
        }
    };

    const handleProcessLab = async () => {
        const pecasNaoFinalizadas = listaPecas.filter(peca => {
            const testesDaPeca = listaTestes.filter(teste => teste.pecas.includes(peca.peca));
            const testesConcluidos = pecasIncluidas.filter(pecaIncluida => pecaIncluida.peca === peca.peca);
            return testesDaPeca.length !== testesConcluidos.length;
        });
    
        if (pecasNaoFinalizadas.length > 0) {
            toast.warning('Existem peças não finalizadas. Finalize todas as peças antes de continuar.');
            return;
        }

        if (isProcessing) {
            return;
        }

        setIsProcessing(true);

        // Mapear TODAS as peças incluídas (independente de aprovação/reprovação)
        const todasPecas = mapearPecasParaModalPerdas();
        
        // SEMPRE mostrar modal se houver peças e a função estiver disponível
        if (todasPecas.length > 0 && finalizarComConfirmacao) {
            const amostraMapeada = mapearAmostraParaModalPerdas();
            
            finalizarComConfirmacao(
                todasPecas,
                amostraMapeada,
                {},
                processarFinal
            );
            setIsProcessing(false);
        } else {
            await processarFinal();
        }
    };

    const handleCheckPeca = (peca) => {
        setPecasSelecionadas(prevPecas => {
            if (prevPecas.includes(peca)) {
                return prevPecas.filter((item) => item !== peca);
            } else {
                return [...prevPecas, peca];
            }
        });
    }

    const handleCheckTeste = (teste) => {
        setTesteEscolhido(teste);
    }

    const handleCheckIndice = (indice) => {
        setIndiceEscolhido(indice);
    }

    const handleFinalizarPeca = () => {
        if (pecasSelecionadas.length === 0) {
            toast.warning('Nenhuma peça selecionada.');
            return;
        }

        if (!testeEscolhido?.id_teste) {
            toast.warning('Teste não selecionado.');
            return;
        }

        if (!indiceEscolhido?.indice && indiceEscolhido !== 'Não se aplica') {
            toast.warning('Índice não selecionado.');
            return;
        }

        if (!statusEscolhido) {
            toast.warning('Status não selecionado.');
            return;
        }

        if (
            (indiceEscolhido.indice === 'APROVADO' && statusEscolhido === 'Reprovado') ||
            (indiceEscolhido.indice === 'REPROVADO' && statusEscolhido === 'Aprovado')
        ) {
            toast.warning('Índice e Status precisam ter valores similares.');
            return;
        }

        const indice = indiceEscolhido === 'Não se aplica' ? indiceEscolhido : indiceEscolhido.indice;

        const novasPecasIncluidas = pecasSelecionadas.map(peca => ({
            id_teste: testeEscolhido.id_teste,
            desc_teste: testeEscolhido.desc_teste,
            peca: peca,
            indice: indice,
            status: statusEscolhido,
            gram_enc: gramaturaEncontrada,
            larg_enc: larguraEncontrada,
            obs: observacoes,
            usuario: userLogin
        }));

        const updatedPecasIncluidas = [...pecasIncluidas, ...novasPecasIncluidas];
        setPecasIncluidas(updatedPecasIncluidas);
        togglePecasDisponiveis(updatedPecasIncluidas);
        resetState();
    }

    function togglePecasDisponiveis(updatedPecasIncluidas) {
        for (let i = 0; i < listaPecas.length; i++) {
            const peca = listaPecas[i].peca;
            const testesComPeca = listaTestes.filter(teste => teste.pecas.includes(peca));
            const testesResolvidos = testesComPeca.every(teste =>
                updatedPecasIncluidas.some(row => row.peca === peca && row.id_teste === teste.id_teste)
            );
            listaPecas[i].disabled = testesResolvidos;
        }
        setListaPecas([...listaPecas]);
    }

    return (
        <Modal
            show={showResultadoTestes}
            onHide={handleCloseResultadoTestes}
            backdrop="static"
            keyboard={false}
            centered
            fullscreen={true}
        >
            <Modal.Header>
                <Modal.Title>Resultado Testes - {acao === 0 ? '100%' : 'Retorno'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={styles.container}>
                    <article className={styles.articleSpacing}>
                        <Accordion defaultActiveKey={['0']} alwaysOpen>
                            <Accordion.Item eventKey="0" disabled>
                                <Accordion.Header>Entrada Fiscal</Accordion.Header>
                                <Accordion.Body className={styles.infoBlockDisplay}>
                                    <div className={styles.infoBlockInline}>
                                        <AccordionItems
                                            linhaSelecionada={linhaSelecionada}
                                        />
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </article>

                    <OptionsSection
                        handleCheckPeca={handleCheckPeca}
                        pecasSelecionadas={pecasSelecionadas}
                        handleCheckTeste={handleCheckTeste}
                        testeEscolhido={testeEscolhido}
                        handleCheckIndice={handleCheckIndice}
                        indiceEscolhido={indiceEscolhido}
                        setStatusEscolhido={setStatusEscolhido}
                        statusEscolhido={statusEscolhido}
                        listaPecas={listaPecas}
                        listaTestes={listaTestes}
                        listaIndicesFiltrada={listaIndicesFiltrada}
                        handleFinalizarPeca={handleFinalizarPeca}
                    />

                    <article>
                        <PecasIncluidas
                            pecas={pecas}
                            setPecas={setPecas}
                            pecasIncluidas={pecasIncluidas}
                            setPecasIncluidas={setPecasIncluidas}
                            linhaSelecionada={linhaSelecionada}
                            listaPecas={listaPecas}
                            setListaPecas={setListaPecas}
                            setListaTestes={setListaTestes}
                            pecasPosicoes={pecasPosicoes}
                            setPecasPosicoes={setPecasPosicoes}
                            togglePecasDisponiveis={togglePecasDisponiveis}
                        />
                    </article>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="outline-danger"
                    className={styles.buttonsFinalizar}
                    onClick={handleCloseResultadoTestes}
                >
                    Cancelar
                </Button>

                <Button
                    variant="primary"
                    className={styles.buttonsFinalizar}
                    onClick={() => handleProcessLab()}
                    disabled={showLoading || isProcessing || pecasIncluidas.length !== qtdeTotalTestes}
                >
                    {isProcessing ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Processando...
                        </>
                    ) : (
                        'Processar'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ResultadoTestes;